import React, { useState } from 'react';
import { exportFptData } from '../services/assujettiService';

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default function V4ReportsPage() {
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function doExport(type: string) {
    setBusy(type);
    setError(null);
    try {
      const blob = await exportFptData(type);
      downloadBlob(blob, `${type}-export.csv`);
    } catch (err: any) {
      setError(err.message || 'Erreur lors de l\'export');
    } finally {
      setBusy(null);
    }
  }

  return (
    <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Rapports</h1>
      <p className="text-gray-500 text-sm mb-6">Exportez vos donnees FPT et licences.</p>

      {error && <div className="mb-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg p-3">{error}</div>}

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex flex-wrap gap-3">
          <button onClick={() => doExport('declarations')} disabled={!!busy} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 disabled:opacity-50">
            {busy === 'declarations' ? 'Export en cours...' : 'Exporter FPT'}
          </button>
          <button onClick={() => doExport('licenses')} disabled={!!busy} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-semibold hover:bg-gray-50 disabled:opacity-50">
            {busy === 'licenses' ? 'Export en cours...' : 'Exporter licences'}
          </button>
          <button onClick={() => doExport('payments')} disabled={!!busy} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-semibold hover:bg-gray-50 disabled:opacity-50">
            {busy === 'payments' ? 'Export en cours...' : 'Calendrier renouvellements'}
          </button>
        </div>
      </div>
    </div>
  );
}
